export default __webpack_public_path__ + "static/media/suggestions_icon.902d749a.png";